/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import React from 'react'

export interface IBatchInfoProps {
	source: string
	alt: string
	title: string
	transactionCount: number
}

export class BatchInfo extends React.Component<IBatchInfoProps> {
	constructor(props: Readonly<IBatchInfoProps>) {
		super(props)
	}

	render(): any {
		return (
			<div style={{ marginLeft: '12px' }}>
				<img src={this.props.source} alt={this.props.alt} title={this.props.title}></img>
				&nbsp; {this.props.transactionCount}
			</div>
		)
	}
}
